import { render } from "./history.vue?vue&type=template&id=1ca6b66d"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=1ca6b66d&lang=css"

import exportComponent from "D:\\site\\online-photo\\watermark-remover-spa\\tipard.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__